import { filter } from 'rxjs/operators';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { AuthService } from '@nrwl/rx-service-auth';
import { DynamicFormComponent } from '../dynamic-form/containers/dynamic-form/dynamic-form.component';
import { FieldConfig } from '../dynamic-form/models/field-config.interface';
import { Router, RouterModule } from '@angular/router';
import { RouterService } from '@nrwl/rx-service-router';
import { Store, select } from '@ngrx/store';
import { AuthSelectors, AuthState, AuthActions } from '@nrwl/rx-state-auth';
import { HttpClient } from '@angular/common/http';
import { environment } from '@nrwl/environment';
import { take } from 'rxjs/operators';
import { LoginModel } from '@nrwl/rx-models';
import { Observable } from 'rxjs';
import { SnackbarService } from '@nrwl/snackbar-services';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RxButtonModule } from '@nrwl/rx-button';
import { RxIconModule } from '@nrwl/rx-icon';
import { DynamicFormModule } from '../dynamic-form/dynamic-form.module';

@Component({
  selector: 'nrwl-dynamic-login',
  templateUrl: './dynamic-login.component.html',
  styleUrls: ['./dynamic-login.component.scss'],
  imports: [
    CommonModule,
    RxIconModule,
    MatTooltipModule,
    RouterModule,
    MatCardModule,
    RxButtonModule,
    DynamicFormModule,
  ],
})
export class DynamicLoginComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(DynamicFormComponent, { static: true })
  public form: DynamicFormComponent;

  public ssoLink$: Observable<any>;
  public formFields: FieldConfig[];
  private code: any = '';

  constructor(
    private store: Store<AuthState.AuthState>,
    private router: Router,
    private routerService: RouterService,
    private authService: AuthService,
    private http: HttpClient,
    private snackbarService: SnackbarService,
  ) {
    this.ssoLink$ = this.store.pipe(select(AuthSelectors.getSsoLink));
  }

  ngOnInit() {
    this.formFields = this.routerService.data.formFields;
    const urlParams = new URLSearchParams(window.location.search);

    // Check for Canva integration first
    if (urlParams.has('user') && urlParams.has('state')) {
      return;
    }

    if (urlParams.has('code')) {
      this.code = <any>urlParams.get('code');
      this.authenticateDrChrono(this.code);
    }

    if (urlParams.has('token')) {
      const token = urlParams.get('token');
      window.location.href = `${environment.rxPhoto}/?token=${token}`;
    }

    if (urlParams.has('error')) {
      this.snackbarService.error(<any>urlParams.get('error'), 5000);
    }

    if (this.router.url.includes('drchrono')) {
      this.openDrchronoModal();
    }
  }

  ngOnDestroy(): void {}

  ngAfterViewInit() {
    setTimeout(() => {
      let previousValid = this.form.valid;
      this.form.changes.pipe(filter(() => this.form.valid !== previousValid)).subscribe(() => {
        previousValid = this.form.valid;
        this.form.setDisabled('submit', !previousValid);
      });

      this.form.setValue('depId', this.authService.getDepId(this.partnerName));

      this.form.setDisabled('submit', true);
    });
  }

  private openDrchronoModal(): void {
    const drChronoClientId = environment.drChronoClientId;
    const currentQueryString = window.location.search; // Get the current query string
    const drChronoLink = `https://drchrono.com/o/authorize/?client_id=${drChronoClientId}&response_type=code&redirect_uri=${
      window.location.protocol
    }//${window.location.host.replace(/\/$/g, '')}${currentQueryString}`;
    window.location.href = drChronoLink;
  }

  private authenticateDrChrono(DrChronoCode: string): void {
    this.authService.clearStorage();
    const currentQueryString = window.location.search; // Get the current query string
    let url: string;
    const endpoint = 'oauth_sso/gateway=DrChrono/target=web/login/?code=' + DrChronoCode;
    url =
      environment.integrationBaseAPIUrlV3 +
      endpoint +
      `&redirect_url=${window.location.protocol}//${window.location.host}`;
    this.http
      .get(url)
      .pipe(take(1))
      .subscribe((data: LoginModel | any) => {
        this.store.dispatch(AuthActions.loginAttempted({ payload: data }));
        this.authService.clearStorage();
      });
  }

  public submit(evt: any): void {
    this.authService.clearStorage();

    if (evt.config?.find((item) => item.sso)) {
      this.ssoLoginStart(evt.email);
      return;
    }

    setTimeout(() => {
      const { username, password, depId, confirmPassword } = this.form.value;

      if (this.router.url.includes('drchrono')) {
        this.openDrchronoModal();
        return;
      }

      const formData: LoginModel = {
        username,
        password,
      };

      if (this.form.value.depId) {
        formData.depId = depId;
        this.authService.setDepId(this.partnerName, depId);
      }

      if (this.router.url.includes('forgot-password')) {
        this.authService.forgotPassword(username);
        return;
      }

      if (this.router.url.includes('reset-password')) {
        this.authService.resetPassword({ password, confirmPassword });
        return;
      }

      if (this.form.valid) {
        this.store.dispatch(AuthActions.loginAttempted({ payload: formData }));
      }
    });
  }

  private get partnerName(): string {
    const parsed = this.router.url.split('/');
    return parsed[parsed.length - 1];
  }

  private ssoLoginStart(email: string) {
    if (this.form.valid) {
      window.location.href = `${environment.ssoBaseUrl}?email=${email}`;
    }
  }
}
